import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Trash } from '@netbasequid/core'
// @ts-ignore
import { ref, sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { setAutoId, AutomationId } from 'utils/automationUtil'
import { Container as CardContainer } from './Card'

const Container = styled(CardContainer).attrs(() =>
  setAutoId(AutomationId.photoConcept.deletedCard)
)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
  gap: 4px;
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  color: ${({ mode }) => sys[mode].text.placeholder};
  text-align: center;
`

interface DeletedCardProps {
  deletedCount?: number
}

const DeletedCard = ({ deletedCount }: DeletedCardProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const iconColor = ref.color.gray[theme === 'light' ? 600 : 900]

  return (
    <Container mode={theme}>
      <Trash fontSize={32} color={iconColor} />
      {t('imageDeletedByAuthor', { count: deletedCount })}
    </Container>
  )
}

export default DeletedCard
